var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePalyStoreBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 64,
    viewBox: "0 0 212 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.656075,
    y: 1.04548,
    width: 209.868,
    height: 61.909,
    rx: 5.83436,
    stroke: "#A6A6A6",
    strokeWidth: 1.29652
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.586 35.472C102.907 35.472 99.9084 38.2989 99.9084 42.1924C99.9084 46.0621 102.907 48.9127 106.586 48.9127C110.266 48.9127 113.265 46.0621 113.265 42.1924C113.263 38.2989 110.265 35.472 106.586 35.472ZM106.586 46.2675C104.57 46.2675 102.832 44.5879 102.832 42.194C102.832 39.7748 104.571 38.1203 106.586 38.1203C108.602 38.1203 110.34 39.7748 110.34 42.194C110.34 44.5863 108.602 46.2675 106.586 46.2675ZM92.0171 35.472C88.3382 35.472 85.3397 38.2989 85.3397 42.1924C85.3397 46.0621 88.3382 48.9127 92.0171 48.9127C95.6977 48.9127 98.6962 46.0621 98.6962 42.1924C98.6962 38.2989 95.6977 35.472 92.0171 35.472ZM92.0171 46.2675C90.0009 46.2675 88.2631 44.5879 88.2631 42.194C88.2631 39.7748 90.0025 38.1203 92.0171 38.1203C94.0334 38.1203 95.7712 39.7748 95.7712 42.194C95.7727 44.5863 94.0334 46.2675 92.0171 46.2675ZM74.6892 37.5357V40.3863H81.4433C81.2415 41.9901 80.7128 43.161 79.9057 43.9748C78.9234 44.9671 77.3858 46.0621 74.6892 46.0621C70.5316 46.0621 67.2812 42.6759 67.2812 38.4759C67.2812 34.2759 70.5316 30.8896 74.6892 30.8896C76.9322 30.8896 78.5699 31.7808 79.779 32.9264L81.7702 30.9149C80.0809 29.2858 77.8394 28.0391 74.6892 28.0391C68.994 28.0391 64.2061 32.7226 64.2061 38.4759C64.2061 44.2292 68.994 48.9127 74.6892 48.9127C77.7628 48.9127 80.0825 47.8935 81.8953 45.9847C83.7598 44.1012 84.3402 41.4529 84.3402 39.3149C84.3402 38.6544 84.2901 38.0429 84.1884 37.5341H74.6892V37.5357ZM145.559 39.7495C145.005 38.2483 143.316 35.472 139.864 35.472C136.437 35.472 133.588 38.1962 133.588 42.1924C133.588 45.9594 136.412 48.9127 140.191 48.9127C143.239 48.9127 145.004 47.0292 145.736 45.9341L143.468 44.4061C142.712 45.5265 141.678 46.2644 140.191 46.2644C138.705 46.2644 137.646 45.577 136.965 44.2276L145.861 40.5111L145.559 39.7495ZM136.487 41.9901C136.412 39.3924 138.478 38.0698 139.965 38.0698C141.125 38.0698 142.107 38.656 142.435 39.4951L136.487 41.9901ZM129.256 48.5066H132.177V28.7533H129.256V48.5066ZM124.466 36.9747H124.366C123.711 36.1847 122.45 35.472 120.864 35.472C117.537 35.472 114.488 38.4253 114.488 42.2192C114.488 45.9863 117.537 48.9143 120.864 48.9143C122.451 48.9143 123.711 48.2016 124.366 47.3879H124.466V48.3549C124.466 50.9258 123.105 52.3005 120.914 52.3005C119.124 52.3005 118.015 51.0032 117.562 49.9082L115.017 50.9779C115.747 52.7588 117.687 54.9488 120.914 54.9488C124.341 54.9488 127.239 52.912 127.239 47.9472V35.8813H124.468V36.9747H124.466ZM121.116 46.2675C119.099 46.2675 117.412 44.561 117.412 42.2192C117.412 39.8506 119.099 38.1203 121.116 38.1203C123.105 38.1203 124.668 39.8506 124.668 42.2192C124.668 44.561 123.105 46.2675 121.116 46.2675ZM159.252 28.7533H152.258V48.5066H155.176V41.0231H159.25C162.485 41.0231 165.666 38.6576 165.666 34.889C165.666 31.1203 162.486 28.7533 159.252 28.7533ZM159.327 38.2736H155.176V31.5027H159.327C161.509 31.5027 162.748 33.3278 162.748 34.889C162.748 36.4185 161.509 38.2736 159.327 38.2736ZM177.365 35.4373C175.252 35.4373 173.063 36.3775 172.158 38.4617L174.748 39.5535C175.302 38.4617 176.334 38.1045 177.415 38.1045C178.924 38.1045 180.459 39.0195 180.484 40.6454V40.8492C179.955 40.5443 178.823 40.0876 177.44 40.0876C174.648 40.0876 171.804 41.6377 171.804 44.5341C171.804 47.1777 174.094 48.8795 176.66 48.8795C178.621 48.8795 179.703 47.9899 180.382 46.947H180.482V48.4718H183.301V40.8982C183.303 37.3935 180.709 35.4373 177.365 35.4373ZM177.011 46.2628C176.057 46.2628 174.723 45.7793 174.723 44.5847C174.723 43.0599 176.384 42.4752 177.819 42.4752C179.1 42.4752 179.705 42.7549 180.484 43.1357C180.257 44.9671 178.698 46.2628 177.011 46.2628ZM193.565 35.8687L190.219 44.433H190.119L186.647 35.8687H183.503L188.71 47.8382L185.741 54.4969H188.785L196.811 35.8687H193.565ZM167.278 48.5066H170.195V28.7533H167.278V48.5066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1787 17.2839C74.1787 18.6081 73.7908 19.662 73.0134 20.4489C72.1312 21.3844 70.98 21.8521 69.566 21.8521C68.2114 21.8521 67.0586 21.3781 66.1123 20.43C65.1644 19.4803 64.6904 18.3047 64.6904 16.9015C64.6904 15.4968 65.1644 14.3212 66.1123 13.3731C67.0586 12.4234 68.2114 11.9494 69.566 11.9494C70.2386 11.9494 70.8814 12.0821 71.4915 12.346C72.1031 12.6115 72.5927 12.9638 72.9587 13.4047L72.1344 14.239C71.5134 13.4884 70.6578 13.1139 69.5644 13.1139C68.5758 13.1139 67.7218 13.4647 67.0007 14.1663C66.2796 14.8679 65.9199 15.7796 65.9199 16.9C65.9199 18.0203 66.2796 18.932 67.0007 19.6336C67.7218 20.3352 68.5758 20.686 69.5644 20.686C70.6124 20.686 71.4868 20.3336 72.186 19.6273C72.6396 19.1674 72.9024 18.5275 72.9727 17.7074H69.5644V16.5681H74.1115C74.1584 16.8162 74.1787 17.0548 74.1787 17.2839Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3897 13.3242H77.1164V16.3296H80.9705V17.4689H77.1164V20.4743H81.3897V21.6405H75.9104V12.1596H81.3897V13.3242Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4747 21.6405H85.2687V13.3242H82.6472V12.1596H89.0963V13.3242H86.4747V21.6405Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7621 21.6405V12.1596H94.9681V21.6405H93.7621Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.316 21.6405H99.1103V13.3242H96.4888V12.1596H102.938V13.3242H100.316V21.6405Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.146 20.4158C114.223 21.3734 113.077 21.8522 111.705 21.8522C110.333 21.8522 109.186 21.3734 108.265 20.4158C107.342 19.4583 106.882 18.2858 106.882 16.9C106.882 15.5142 107.342 14.3418 108.265 13.3842C109.186 12.4267 110.333 11.9463 111.705 11.9463C113.069 11.9463 114.214 12.4282 115.14 13.3905C116.066 14.3528 116.529 15.5221 116.529 16.9C116.529 18.2858 116.067 19.4583 115.146 20.4158ZM109.155 19.621C109.85 20.3321 110.699 20.686 111.705 20.686C112.71 20.686 113.561 20.3305 114.254 19.621C114.949 18.91 115.298 18.003 115.298 16.9C115.298 15.7971 114.949 14.8901 114.254 14.179C113.561 13.468 112.71 13.114 111.705 13.114C110.699 13.114 109.85 13.4695 109.155 14.179C108.462 14.8901 108.113 15.7971 108.113 16.9C108.113 18.003 108.462 18.91 109.155 19.621Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.221 21.6405V12.1596H119.688L124.249 19.5341H124.301L124.249 17.7075V12.1596H125.455V21.6405H124.196L119.424 13.9073H119.372L119.424 15.7339V21.6405H118.221Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1787 17.2839C74.1787 18.6081 73.7908 19.662 73.0134 20.4489C72.1312 21.3844 70.98 21.8521 69.566 21.8521C68.2114 21.8521 67.0586 21.3781 66.1123 20.43C65.1644 19.4803 64.6904 18.3047 64.6904 16.9015C64.6904 15.4968 65.1644 14.3212 66.1123 13.3731C67.0586 12.4234 68.2114 11.9494 69.566 11.9494C70.2386 11.9494 70.8814 12.0821 71.4915 12.346C72.1031 12.6115 72.5927 12.9638 72.9587 13.4047L72.1344 14.239C71.5134 13.4884 70.6578 13.1139 69.5644 13.1139C68.5758 13.1139 67.7218 13.4647 67.0007 14.1663C66.2796 14.8679 65.9199 15.7796 65.9199 16.9C65.9199 18.0203 66.2796 18.932 67.0007 19.6336C67.7218 20.3352 68.5758 20.686 69.5644 20.686C70.6124 20.686 71.4868 20.3336 72.186 19.6273C72.6396 19.1674 72.9024 18.5275 72.9727 17.7074H69.5644V16.5681H74.1115C74.1584 16.8162 74.1787 17.0548 74.1787 17.2839Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3897 13.3242H77.1164V16.3296H80.9705V17.4689H77.1164V20.4743H81.3897V21.6405H75.9104V12.1596H81.3897V13.3242Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4747 21.6405H85.2687V13.3242H82.6472V12.1596H89.0963V13.3242H86.4747V21.6405Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7621 21.6405V12.1596H94.9681V21.6405H93.7621Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.316 21.6405H99.1103V13.3242H96.4888V12.1596H102.938V13.3242H100.316V21.6405Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.146 20.4158C114.223 21.3734 113.077 21.8522 111.705 21.8522C110.333 21.8522 109.186 21.3734 108.265 20.4158C107.342 19.4583 106.882 18.2858 106.882 16.9C106.882 15.5142 107.342 14.3418 108.265 13.3842C109.186 12.4267 110.333 11.9463 111.705 11.9463C113.069 11.9463 114.214 12.4282 115.14 13.3905C116.066 14.3528 116.529 15.5221 116.529 16.9C116.529 18.2858 116.067 19.4583 115.146 20.4158ZM109.155 19.621C109.85 20.3321 110.699 20.686 111.705 20.686C112.71 20.686 113.561 20.3305 114.254 19.621C114.949 18.91 115.298 18.003 115.298 16.9C115.298 15.7971 114.949 14.8901 114.254 14.179C113.561 13.468 112.71 13.114 111.705 13.114C110.699 13.114 109.85 13.4695 109.155 14.179C108.462 14.8901 108.113 15.7971 108.113 16.9C108.113 18.003 108.462 18.91 109.155 19.621Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.221 21.6405V12.1596H119.688L124.249 19.5341H124.301L124.249 17.7075V12.1596H125.455V21.6405H124.196L119.424 13.9073H119.372L119.424 15.7339V21.6405H118.221Z",
    stroke: "white",
    strokeWidth: 0.259305,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_984_3658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3346 13.0091C15.8794 13.4958 15.6104 14.2511 15.6104 15.2292V50.1756C15.6104 51.1553 15.8794 51.909 16.3346 52.3957L16.4503 52.5095L35.8289 32.9331V32.7024V32.4717L16.4503 12.8938L16.3346 13.0091Z",
    fill: "url(#paint0_linear_984_3658)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2895 39.4607L35.8311 32.9332V32.7025V32.4718L42.2911 25.9458L42.4366 26.0295L50.0901 30.4223C52.2753 31.677 52.2753 33.7296 50.0901 34.9858L42.4366 39.3786L42.2895 39.4607Z",
    fill: "url(#paint1_linear_984_3658)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_984_3658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4358 39.3764L35.8287 32.7019L16.3359 52.3952C17.0555 53.1663 18.2458 53.2611 19.5863 52.4931L42.4358 39.3764Z",
    fill: "url(#paint2_linear_984_3658)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.4358 26.0293L19.5863 12.9141C18.2458 12.1446 17.0555 12.241 16.3359 13.0121L35.8303 32.7053L42.4358 26.0293Z",
    fill: "url(#paint3_linear_984_3658)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_984_3658",
    x: 15.6104,
    y: 12.3831,
    width: 36.1182,
    height: 40.6406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.194479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_984_3658"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.194479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_984_3658",
    result: "effect2_innerShadow_984_3658"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_984_3658",
    x: 16.3359,
    y: 32.7019,
    width: 26.0996,
    height: 20.3218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.194479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_984_3658"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_3658",
    x1: 34.1111,
    y1: 14.8595,
    x2: 7.59461,
    y2: 41.1082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_3658",
    x1: 52.9346,
    y1: 32.7025,
    x2: 15.0879,
    y2: 32.7025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_984_3658",
    x1: 38.8478,
    y1: 36.3266,
    x2: 2.88802,
    y2: 71.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_984_3658",
    x1: 11.4266,
    y1: 1.37877,
    x2: 27.4836,
    y2: 17.2736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePalyStoreBadge);
export default __webpack_public_path__ + "static/media/google-paly-store-badge.fa1f49b747491731c5f65bd9ed80fcff.svg";
export { ForwardRef as ReactComponent };